import React from 'react';
import PropTypes from 'prop-types';

import IconProductDescription from "./IconProductDescription.js";
import ProductDescription from "./ProductDescription.js";
import { Button, Container, Header, Grid, Segment } from "semantic-ui-react";
import { Link } from 'react-router-dom';

import './styles.css';

const SplitPane = ({ copy, highlighted, withButton }) => {
  const columnCount = copy.columns.length;
  const highlightClassName = highlighted ? 'highlight' : null
  return (
    <Segment basic padded className={`${highlightClassName} no-margin`}>
      <div className={`${highlightClassName}`}>
        <Segment basic className={`${highlightClassName}`}>
          <Container text>
            <Header as='h2'>{copy.header}</Header>
            <p>{copy.subheader}</p>
          </Container>
        </Segment>
        <Container className='center-flex text-width'>
          <Grid stackable relaxed='very' columns={columnCount}>
            {copy.columns.map((content, i) => {
              return (
                <Grid.Column key={i}>
                  {content.iconName ?
                    <IconProductDescription content={content} />
                    :
                    <ProductDescription content={content} />
                  }
                </Grid.Column>
              )
            })}
          </Grid>
        </Container>
      </div>
      {withButton ?
        <div className={`${highlightClassName} padded-button pad-bottom center-flex`}>
          <Link to="/contact">
            <Button secondary size='huge' >{copy.buttonCopy}</Button>
          </Link>
        </div>
        :
        null
      }
    </Segment>
  );
};



export default SplitPane;

SplitPane.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  withButton: PropTypes.bool.isRequired,
  copy: PropTypes.shape({
    header: PropTypes.string.isRequired,
    subheader: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    buttonCopy: PropTypes.string,
    bottonUrl: PropTypes.string,
    cta: PropTypes.string
  }).isRequired
}


// WEBPACK FOOTER //
// ./src/Product/SplitPane.js